import { render, staticRenderFns } from "./BaseSelectInputWorkingHours.vue?vue&type=template&id=50274230"
import script from "./BaseSelectInputWorkingHours.vue?vue&type=script&lang=js"
export * from "./BaseSelectInputWorkingHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports